import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-muted text-[11px]"
}
const _hoisted_2 = { class: "md:hidden" }
const _hoisted_3 = {
  key: 1,
  class: "text-success font-medium text-[11px] flex flex-wrap gap-1"
}
const _hoisted_4 = {
  key: 2,
  class: "text-error font-medium text-[11px] flex flex-wrap gap-1"
}


import { HourPersonalInfo } from "@/types/calculators";


export default /*@__PURE__*/_defineComponent({
  __name: 'TenGodsComponent',
  props: {
    personal: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (
      __props.personal.positive_markers.length === 0 &&
      __props.personal.negative_markers.length === 0
    )
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t("calculators.personal-date.full-day-report.hourlyTable.tenGods")), 1),
          _cache[0] || (_cache[0] = _createTextVNode(" 食神 / 正财 ", -1))
        ]))
      : _createCommentVNode("", true),
    (__props.personal.positive_markers.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.personal.positive_markers, (positive, index) => {
            return (_openBlock(), _createElementBlock("span", { key: index }, _toDisplayString(positive), 1))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (__props.personal.negative_markers.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.personal.negative_markers, (negative, index) => {
            return (_openBlock(), _createElementBlock("span", { key: index }, _toDisplayString(negative), 1))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})